
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/login",
      function () {
        return require("private-next-pages/partner/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/login"])
      });
    }
  